module.exports = __webpack_public_path__ + "static/media/logo.5a09d135.svg";